// src/api/apiClient.js

import axios from 'axios';

// 建立 axios 實例
const apiClient = axios.create({
    baseURL: process.env.REACT_APP_API_URL + '/api',
});

// 請求攔截器 (Request Interceptor)
// 只保留處理 Authorization (admin_token) 的邏輯
apiClient.interceptors.request.use(config => {
    const token = localStorage.getItem('admin_token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, error => {
    return Promise.reject(error);
});

// 回應攔截器 (Response Interceptor)
// 刪除了原本複雜的 403 Retry 邏輯，現在只需簡單回傳或報錯
apiClient.interceptors.response.use(
    response => response,
    error => {
        // 如果有需要統一處理錯誤 (例如 401 登出)，可以在這裡加
        return Promise.reject(error);
    }
);

// 刪除了 loadOrInitializeTokens 函數，因為不再需要初始化安全 Token

export default apiClient;